import React, { Component } from "react";
import {
  profile,
  alert,
  float,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DateRangePicker,
  Select,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  XLSX,
  saveAs,
  StatusTnx,
  linkRole,
} from "../../components/CustomComponent.js";
import Footer from "../../components/Footer.js";
import LOGOLARGE from "../../assets/images/logo512.png";
import NOPRODUCT from "../../assets/images/no-order.png";
import PLACEHOLDER from "../../assets/images/placeholder.png";
import {
  XShareButton,
  XIcon,
  FacebookShareButton,
  FacebookIcon,
  LineShareButton,
  LineIcon,
  PinterestShareButton,
  PinterestIcon,
  TelegramShareButton,
  TelegramIcon,
} from "react-share";

import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      product_image: "",
      product_name: " ",
      price: "",
      sold: "",

      quantity: 1,

      data_product: [],
      data_category: global.category
        .sort(() => Math.random() - 0.5)
        .slice(0, 4),
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get();
    if (params("pd") || params("pc")) {
      this.GetByID(params("pd") || "", params("pc") || "");
    }
  }

  Get = async () => {
    let [result] = await Promise.all([
      GET("v1/market/products", {
        page: Math.floor(Math.random() * 50) + 1,
        page_size: 48,
        data_search: "",
      }),
    ]);
    if (result?.status) {
      this.setState({
        data_product: result.data
          .filter((e) => e.product_image)
          .sort(() => Math.random() - 0.5),
      });
    } else {
      localStorage.clear();
      alert(
        "/",
        "warning",
        "แจ้งเตือน",
        "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
      );
    }
  };
  GetByID = async (uid, code) => {
    let [result] = await Promise.all([
      GET("v1/market/products", { uid, product_code: code }),
    ]);
    if (result?.status === true) {
      this.setState({
        product_image: result.data?.product_image || "",
        product_name: result.data?.product_name || "",
        price: result.data?.price || "",
        sold: result.data?.sold || "",
      });
      console.log(result.data)
    }
  };
  render() {
    const {
      filter_search,

      data_product,
      data_category,
      product_image,
      product_name,
      price,
      sold,

      quantity,
    } = this.state;
    return !product_name ? (
      <div className="w-100 min-vh-100 position-relative">
        <Navbar />
        {/* SECTION 1 - ค้นหา */}
        <div className="w-100 bg-orange p-4 pb-2">
          <div className="container">
            <div className="d-flex mb-1 position-relative">
              <input
                className="form-control hpx-50"
                placeholder="ค้นหาสินค้า..."
                onChange={(e) =>
                  this.setState({ filter_search: e.target.value })
                }
                value={filter_search}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    window.location.href = `/product?keyword=${filter_search}`;
                  }
                }}
              />
              <button
                className="btn bg-orange fw-bold text-white px-4 ms-2 position-absolute"
                style={{ height: 42, right: 4, top: 4 }}
                onClick={() =>
                  (window.location.href = `/product?keyword=${filter_search}`)
                }
              >
                <span className="icon">{"\uf002"}</span>
              </button>
            </div>
            <div>
              {data_category.map((item, index) => (
                <button
                  key={index}
                  className="btn btn-link text-light text-decoration-none"
                  onClick={() =>
                    (window.location.href = `/product?category=${item.name}`)
                  }
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="min-vh-100 text-center py-5">
          <img alt="ไม่มีสินค้า" src={NOPRODUCT} className="wpx-300" />
          <h2 className="fw-bold mt-4">ไม่มีสินค้านี้ในระบบ</h2>
          <span className="text-secondary d-block mb-4">
            ขออภัย สินค้าที่คุณกำลังค้นหาอาจถูกลบออก หรือไม่มีอยู่จริง
          </span>
          <a className="btn btn-dark px-4 text-decoration-none" href="/product">
            เลือกชมสินค้าอื่นๆ
          </a>
        </div>
        <Footer />
      </div>
    ) : (
      <div className="w-100 min-vh-100 position-relative">
        <Navbar />
        {/* SECTION 1 - ค้นหา */}
        <div className="w-100 bg-orange p-4 pb-2">
          <div className="container">
            <div className="d-flex mb-1 position-relative">
              <input
                className="form-control hpx-50"
                placeholder="ค้นหาสินค้า..."
                onChange={(e) =>
                  this.setState({ filter_search: e.target.value })
                }
                value={filter_search}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    window.location.href = `/product?keyword=${filter_search}`;
                  }
                }}
              />
              <button
                className="btn bg-orange fw-bold text-white px-4 ms-2 position-absolute"
                style={{ height: 42, right: 4, top: 4 }}
                onClick={() =>
                  (window.location.href = `/product?keyword=${filter_search}`)
                }
              >
                <span className="icon">{"\uf002"}</span>
              </button>
            </div>
            <div>
              {data_category.map((item, index) => (
                <button
                  key={index}
                  className="btn btn-link text-light text-decoration-none"
                  onClick={() =>
                    (window.location.href = `/product?category=${item.name}`)
                  }
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="container bg-light my-4 p-3">
          <div className="row">
            <div className="col-12 col-md-5 mb-3 mb-md-0">
              <div className="placeholder-box w-100 rounded-0">
                <img
                  alt="THUMBNAIL"
                  src={product_image || PLACEHOLDER}
                  className="h-100 w-100 bg-secondary-light"
                  style={{ objectFit: "cover", minHeight: 300, maxHeight: 500 }}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = PLACEHOLDER;
                  }}
                />
              </div>
              {/* ส่วนที่เพิ่มใหม่: ปุ่มแชร์ Social Media (แบบเปิดแท็บใหม่) */}
              <div className="mt-4 d-flex align-items-center justify-content-center justify-content-md-start">
                <span className="me-3 fw-bold text-secondary">แชร์ :</span>
                <div className="d-flex gap-2">
                  <FacebookShareButton
                    url={window.location.href}
                    aria-label="Share this page on Facebook"
                  >
                    <FacebookIcon size={30} round />
                  </FacebookShareButton>
                  <LineShareButton
                    title="Read this next"
                    url={window.location.href}
                    aria-label="Share on Line"
                  >
                    <LineIcon size={30} round />
                  </LineShareButton>
                  <XShareButton
                    title="Share title sent to X"
                    htmlTitle="Native button tooltip"
                    url={window.location.href}
                    aria-label="Share on X"
                  >
                    <XIcon size={30} round />
                  </XShareButton>
                  <PinterestShareButton
                    media={product_image || PLACEHOLDER}
                    description="Pin this"
                    url={window.location.href}
                    aria-label="Pin on Pinterest"
                  >
                    <PinterestIcon size={30} round />
                  </PinterestShareButton>
                  <TelegramShareButton
                    title="Read this next"
                    url={window.location.href}
                    aria-label="Share on Telegram"
                  >
                    <TelegramIcon size={30} round />
                  </TelegramShareButton>
                </div>
              </div>
              {/* สิ้นสุดส่วนที่เพิ่มใหม่ */}
            </div>
            <div className="col-12 col-md-7 mb-3 py-4">
              <h3 className="fw-bold">{product_name}</h3>
              <div className="d-flex">
                <div className="d-flex me-5">
                  <span>ขายแล้ว</span>
                  <b className="mx-2">{sold}</b>
                  <span>ชิ้น</span>
                </div>
              </div>
              <hr />
              <div className="w-100 mb-4 d-flex align-items-center">
                <h2 className="fw-bold text-orange mb-0">฿{toFixed(price)}</h2>
                <h5 className="fw-bold text-secondary mx-3 mb-0">
                  <s>฿{toFixed(price * 1.5)}</s>
                </h5>
                <small className="bg-orange px-2 rounded-2">-33%</small>
              </div>
              <div className="d-flex mb-3">
                <span className="wpx-40 icon text-orange">{"\uf0d1"}</span>
                <div className="fw-bold me-2">
                  จัดส่งสินค้าภายใน{" "}
                  {format_date(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      new Date().getDate() + 15,
                    ),
                    "dd mmm",
                  )}{" "}
                  -{" "}
                  {format_date(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      new Date().getDate() + 20,
                    ),
                    "dd mmm",
                  )}
                </div>
              </div>
              <div className="d-flex mb-5">
                <span className="wpx-40 icon text-orange">{"\uf132"}</span>
                <div className="fw-bold me-2">ประกันสินค้าเสียหาย</div>
              </div>
              <div className="d-flex">
                <button
                  className="d-none d-md-block btn btn-dark me-2 px-4 py-2 hpx-50"
                  onClick={() => {
                    let cart = localStorage.getItem("cart");
                    cart = cart ? JSON.parse(cart) : [];
                    let _index = cart.findIndex(
                      (e) => e.product_name === product_name,
                    );
                    if (_index === -1) {
                      cart.push({
                        product_image,
                        product_name,
                        price,
                        quantity,
                      });
                    } else {
                      cart[_index].quantity += quantity;
                    }
                    localStorage.setItem("cart", JSON.stringify(cart));
                    alert(
                      "#",
                      "success",
                      "สำเร็จ",
                      "เพิ่มสินค้าไปยังตะกร้าของคุณเรียบร้อยแล้ว",
                    );
                  }}
                >
                  <span className="icon me-2">{"\uf291"}</span>
                  เพิ่มลงตะกร้า
                </button>
                <button
                  className="d-none d-md-block btn bg-orange me-2 px-4 py-2 hpx-50"
                  onClick={() => {
                    let cart = localStorage.getItem("cart");
                    cart = cart ? JSON.parse(cart) : [];
                    let _index = cart.findIndex(
                      (e) => e.product_name === product_name,
                    );
                    if (_index === -1) {
                      cart.push({
                        product_image,
                        product_name,
                        price,
                        quantity,
                      });
                    } else {
                      cart[_index].quantity += quantity;
                    }
                    localStorage.setItem("cart", JSON.stringify(cart));
                    alert(
                      "/cart",
                      "success",
                      "สำเร็จ",
                      "เพิ่มสินค้าไปยังตะกร้าของคุณเรียบร้อยแล้ว",
                    );
                  }}
                >
                  <span className="icon me-2">{"\uf0d1"}</span>
                  ซื้อสินค้า
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 3 */}
        <div className="container">
          <div className="col-12 mb-4">
            <h5 className="fw-bold mb-4">สินค้าอื่นๆ</h5>
            <div className="row">
              {data_product.map((item, index) => (
                <div
                  className="col-6 col-sm-4 col-md-3 col-xl-2 px-1 mb-2"
                  onClick={() => {
                    window.location.href = "/product-detail?pd=" + item.uid;
                  }}
                >
                  <div className="p-1 bg-light product">
                    <div
                      className="bg-secondary-light"
                      style={{
                        inset: 0,
                        margin: "auto",
                        height: "100%",
                        aspectRatio: "1 / 1",
                        pointerEvents: "none",
                        position: "relative",
                      }}
                    >
                      <img
                        alt="Logo"
                        src={item.product_image || LOGOLARGE}
                        height={"100%"}
                        width={"100%"}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = LOGOLARGE;
                        }}
                      />
                    </div>
                    <div className="p-2">
                      <div
                        className="overflow-hidden"
                        style={{ lineHeight: 1.2, height: 36 }}
                      >
                        {item?.product_name}
                      </div>
                      <h5 className="fw-bold">
                        ฿{toFixed(Number(item?.price), 2)}
                      </h5>
                      <div className="d-flex justify-content-between">
                        <small className="text-secondary">
                          ขายได้ {item?.sold} ชิ้น
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="hpx-100"></div>
        <button
          className="d-block d-md-none btn bg-orange w-100 px-4 py-3 position-fixed rounded-0 shadow"
          style={{ bottom: 0 }}
          onClick={() => {
            let cart = localStorage.getItem("cart");
            cart = cart ? JSON.parse(cart) : [];
            let _index = cart.findIndex((e) => e.product_name === product_name);
            if (_index === -1) {
              cart.push({
                product_image,
                product_name,
                price,
                quantity,
              });
            } else {
              cart[_index].quantity += quantity;
            }
            localStorage.setItem("cart", JSON.stringify(cart));
            alert(
              "#",
              "success",
              "สำเร็จ",
              "เพิ่มสินค้าไปยังตะกร้าของคุณเรียบร้อยแล้ว",
            );
          }}
        >
          เพิ่มลงตะกร้า
        </button>
        <Footer />
      </div>
    );
  }
}
